import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class ProjectExpirationReportController {
  constructor($rootScope, $uibModal, $state, $http) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.queryResult;
    this.$rootScope = $rootScope;
    this.customerFilter = 'all';
    this.contractFilter = 'all';
    this.taskFilter = 'all';
    this.formatCurrency = formatCurrency;

    let self = this;

    this.$http.get(this.$rootScope.apiHost+"/api/reports/projectexpirationreport", {withCredentials: true}).then(function (success) {
      self.report = success.data;
      self.queryParams = self.report.filterParameters;
      self.search();
    });


  }

  search() {
    let self = this;
    this.$http.post(this.$rootScope.apiHost+"/api/reports/projectexpirationreport", this.queryParams, {withCredentials: true}).then(function (success) {
      self.queryResult = success.data;
    });
  }




}

export default ProjectExpirationReportController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/project-expiration-report/project-expiration-report.controller.js